<div class="wa-stack">
<form>
    <div class="wa-split wa-align-items-end">
      <div class="wa-cluster">
        <wa-input label="Module code"
                  type="text"
                  [formControl]="moduleCodeFilter"
                  placeholder="module code">
        </wa-input>
        <wa-input label="Module name"
                  type="text"
                  [formControl]="moduleNameFilter"
                  placeholder="module name">
        </wa-input>
      </div>
      <div>
        <wa-button variant="brand" (click)="resetFilter()">
          <wa-icon name="filter-slash" variant="solid" label="filter"></wa-icon>
          reset filters
        </wa-button>
      </div>
    </div>
  </form>
@if (exams.isLoading()) {
  <wa-callout variant="neutral">
  <wa-spinner slot="icon"></wa-spinner>
   Please wait while we load the exams for the selected semester.
</wa-callout>
} @else {
  @if (!examsView() || examsView().length === 0) {
    @if (user()?.isAdmin) {
      <wa-callout variant="warning">
        <wa-icon slot="icon" name="triangle-exclamation" variant="regular"></wa-icon>
        <strong>No exams found for current filter setting</strong><br/>
      </wa-callout>
    } @if (!user()?.isAdmin || filter !== defaultFilter) {
      <wa-callout variant="warning">
        <wa-icon slot="icon" name="triangle-exclamation" variant="regular"></wa-icon>
        <strong>No exams found.</strong><br/>
        Currently, no exams are available for the selected semester.
      </wa-callout>
    }
  }
} @if (exams.hasValue()) {
  <wa-divider></wa-divider>
  <wa-scroller orientation="vertical" class="survey-scroller">
    <div class="wa-stack" style="--min-column-size: 30ch;">
      @for (exam of examsView(); track exam.id) {
        <app-exam-list-element
        [exam]="exam"
        [showControls]="!!user() && user()!.isAdmin"
        (editCorrections)="editCorrections($event)"
        (editSupervisions)="editSupervisions($event)">
      </app-exam-list-element>
      }
    </div>
  </wa-scroller>
}
</div>
